import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

export type ResellerCustomer = {
  email: string;
  id: number;
  is_active: boolean;
  last_modified: string;
  name: string;
  phone: string;
  registration_date: string;
};

export type ResellerCustomerResponse = {
  count: number;
  result: ResellerCustomer;
  total_results: number;
};

export const useGetResellerCustomer = (customerId: string) => {
  const fetchResellers = async () => {
    const response = await Axios.get<ResellerCustomerResponse>(
      `${GET_URL(customerId).reseller}`
    );
    return response.data;
  };

  return useQuery<ResellerCustomerResponse, AxiosError<BaseError>>(
    QueryKeys.reseller(customerId),
    fetchResellers
  );
};
